import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { LoginPage } from './pages/Login';
import { TodayPage } from './pages/Today';
import { StatsPage } from './pages/Stats';
import { ChangePasswordPage } from './pages/ChangePassword';

export function App() {
  const { player } = useAuth();
  const location = useLocation();

  // Force-Redirect: wer ein neues Passwort setzen muss, wird sofort
  // auf /change-password umgeleitet — egal welche Seite ursprünglich
  // angesteuert wurde.
  const mustChange = player?.must_change_password === true;
  const onChangePage = location.pathname === '/change-password';
  if (player && mustChange && !onChangePage) {
    return <Navigate to="/change-password" replace />;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={player ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        path="/change-password"
        element={player ? <ChangePasswordPage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/"
        element={player ? <TodayPage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/stats"
        element={player ? <StatsPage /> : <Navigate to="/login" replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
